import { ENERGY_TYPES, EnergyType } from '@boltenergy-be/shared'
import { PriceHistoryType } from 'store/queries/bolt-api/metrics/types.ts'
import { PriceHistoryMetrics } from 'store/queries/bolt-api/contracts/types.ts'

/** The getPriceHistory query type per energy type */
export const PRICE_HISTORY_QUERY_TYPE: Record<EnergyType, PriceHistoryType> = {
  [ENERGY_TYPES.electricity]: PriceHistoryType.PRICE_ELECTRICITY,
  [ENERGY_TYPES.gas]: PriceHistoryType.PRICE_GAS
}

/** The getPriceHistory response key per energy type */
export const PRICE_HISTORY_RESPONSE_KEY: Record<EnergyType, keyof PriceHistoryMetrics> = {
  [ENERGY_TYPES.electricity]: 'electricity',
  [ENERGY_TYPES.gas]: 'gas'
}
